<template>
  <div class="addReduce">
    <!-- add balace email -->
    <div v-if="actionAdd">
      <a data-cy="addLineBalance" class="text-gray-600 addValue d-flex align-items-stretch" @click.stop.stop="addValue">
        <template v-if="isActive">
          <span class="font-3xl mr-1" style="line-height: 0.8em">-</span>
          <span style="line-height: 1.6em text-underline">{{ $t(`backoffice.manage.balance.tables.components.add-value.cancel`) }}</span>
        </template>
        <template v-else>
          <span class="font-3xl mr-1" style="line-height: 0.8em">+</span>
          <span style="line-height: 1.6em text-underline">{{ $t(`backoffice.manage.balance.tables.components.add-value.add`) }}</span>
        </template>
      </a>
    </div>
    <div class="absolute-center" v-if="isActive" @click.stop>
      <transition name="fade">
        <div class="dataTable__popUp bg-white p-3 shadow-sm">
          <div class="d-flex">
            <span class="addReduce__inputBefore text-success">+</span>
            <CInput
              @click.stop
              data-cy="valueBalance"
              class="addReduce__input pl-2 w-100"
              :class="item._modalTypeValueActive == 'add' ? 'text-success' : 'text-danger'"
              type="number"
              :value.sync="$v.currentBalanceTemp.$model"
              :min="item._modalTypeValueActive == 'add' ? 0 : item.balance"
              :max="item._modalTypeValueActive == 'remove' ? item.balance : 999999999999"
              :invalidFeedback="$t('auth.newRegister.inputFeedback.required')"
              @keypress="isNumber($event)"
              @blur="maxAndMinRemove($event, { type: item._modalTypeValueActive, maxValue: item.balance })"
              @input="maxAndMinRemove($event, { type: item._modalTypeValueActive, maxValue: item.balance })"
              :placeholder="$t(`backoffice.manage.balance.tables.components.input.placeholder.value`)"
            />
          </div>
          <p class="m-0 text-uppercase font-xs">{{ $t(`backoffice.manage.balance.tables.components.add-value.balance`) }}</p>
          <p class="mb-3 block">
            {{ Number(currentBalanceTemp) + Number(item.balance) }}
          </p>
          <p class="m-0 text-uppercase font-xs">{{ $t(`backoffice.manage.balance.tables.components.add-value.reason`) }}</p>
          <textarea
            maxlength="250"
            v-model="reason"
            data-cy="reasonBalance"
            class="addReduce__input font-xs w-100"
            :placeholder="$t(`backoffice.manage.balance.tables.components.placeholder.reason`)"
          />

          <div>
            <CButton
              :data-cy="'updateLineBalace' + index"
              color="primary"
              :disabled="reason.length == 0 || currentBalanceTemp == 0 || disabled == true"
              @click="addBalance(item)"
            >
              <CIcon name="check" class="mx-1" size="custom-size" :height="12" viewBox="0 0 32 32" />
            </CButton>
            <CButton :data-cy="'closeBalace' + index" color="gray-200 ml-1" @click="isActive = false">
              <CIcon name="backArrow" class="mx-1" size="custom-size" :height="12" viewBox="0 0 32 32" />
            </CButton>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'AddReduceBalance',
  props: {
    actionsButtons: {
      type: Boolean,
      default: () => true,
    },
    actionAdd: {
      type: Boolean,
      default: () => false,
    },
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },

  mixins: [validationMixin],

  validations: {
    currentBalanceTemp: {
      required,
      minLength: minLength(0),
      maxLength: maxLength(0),
    },
  },

  data() {
    return {
      disabled: false,
      isActive: false,
      currentBalanceTemp: null,
      organizationId: null,
      reason: '',
    }
  },

  created() {
    this.organizationId = this.$route.params.organizationId

    this.$root.$on('update-close-popup', () => {
      this.closePopUp()
    })
  },

  beforeDestroy() {
    this.$root.$off('update-close-popup')
  },

  methods: {
    checkIfValid(value, fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      return !(field.$invalid || field.$model === '')
    },

    addValue() {
      this.isActive = !this.isActive
      this.value = ''
    },

    isNumber(evt, data = {}) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },

    maxAndMinRemove(value, { type, maxValue }) {
      if (type == 'remove') {
        let handlerValue = value.target?.value || value

        if (handlerValue > maxValue) {
          this.currentBalanceTemp = maxValue
        }
      }
    },

    closePopUp() {
      this.isActive = false
    },

    addLineBalace() {
      this.$emit('add-country', {
        currentBalanceTemp: Number(this.currentBalanceTemp),
        reason: this.reason,
      })

      this.currentBalanceTemp = ''
      this.reason = ''
      this.isActive = false
    },

    updateLineBalace(item) {
      let value = 0

      if (item._modalTypeValueActive == 'remove') {
        value = Number(item.balance) - Number(this.currentBalanceTemp)
      } else {
        value = Number(this.currentBalanceTemp) + Number(item.balance)
      }

      this.$emit('update-LineBalace', {
        id: item.id,
        currentBalanceTemp: value,
        reason: this.reason,
      })

      this.currentBalanceTemp = ''
      this.reason = ''
    },

    toggleInputValueAll() {
      this.$emit('toggle-inputValueAll')
    },

    addBalance(item) {
      this.setDisabled()

      this.$emit('add-balance', {
        ...item,
        organizationId: this.organizationId,
        balance: Number(this.currentBalanceTemp),
        reason: this.reason,
      })
    },

    closeConfirmationInputValue(item, index) {
      this.$emit('close-confirmation-inputValuel', { item, index })
    },

    toggleInputValue(item, index, type = '') {
      this.$nextTick(() => {
        this.$emit('toggle-inputValue', { item, index, type })
      })
    },

    openInputValue(item, index) {
      this.$emit('open-confirmation-inputValue', { item, index })
    },

    setDisabled() {
      this.disabled = true
      setTimeout(() => {
        this.disabled = false
      }, 2000)
    },
  },
}
</script>

<style lang="scss" scope>
.addReduce {
  &__inputBefore {
    line-height: 52px !important;
  }
  &__inputBefore,
  &__input {
    height: 52px;
    appearance: none;
    border: none;
    padding: 0 0 0.5rem;
    border-bottom: 1px solid var(--gray-500);

    &:active,
    &:focus {
      appearance: none;
      outline: none;
    }
  }

  .addValue {
    cursor: pointer;
  }
}

.tableBalance {
  &__btn {
    width: 30px;
    height: 30px;
    line-height: 15px;
    padding: 5px;
    transition: box-shadow 300ms;
    background: white;
    &--active,
    &:hover:enabled {
      background: white;
      box-shadow: 0px 5px 9px 0 rgba(34, 37, 43, 0.13) !important;
    }
  }
}
</style>
